import { useState } from "react";
import { FilterValue, GroupFilter } from "../../types/filter";
import { FilterTabs } from "../FilterTabs/FilterTabs";
import { FilterAccordionItem } from "./FilterAccordionItem";
import { getFilterValueCount } from "../../utils/filter/filtervalue";

interface AccordionGroupProps {
  filter: GroupFilter;
  filterValues: FilterValue[];
  setFilterValues: (filterValues: FilterValue[]) => void;
  open: boolean;
  onOpenChange: (isOpen: boolean) => void;
}

export const AccordionGroup = ({
  filter,
  filterValues,
  setFilterValues,
  open,
  onOpenChange,
}: AccordionGroupProps) => {
  const [listBoxIsOpen, setListBoxIsOpen] = useState(false);
  const filterValueCount = getFilterValueCount(filter, filterValues);
  const { title } = filter;

  return (
    <FilterAccordionItem
      filter={filter}
      open={!!open}
      onOpenChange={onOpenChange}
      title={filterValueCount ? `${title} (${filterValueCount})` : title}
    >
      <FilterTabs
        filter={filter}
        filterValues={filterValues}
        setFilterValues={(filterValues) => {
          setFilterValues(filterValues);
          setListBoxIsOpen(!listBoxIsOpen);
        }}
      />
    </FilterAccordionItem>
  );
};
